import axios from 'axios';
import store from '@/store';
import { getToken } from '@/utils/auth';
import { Message } from 'element-ui';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
  // timeout: 5000,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    if(config.customIP) {
      config.baseURL = config.customIP;
    }

    // if(config.requestBase == 'VUE_APP_BASE_API3') {
    //   config.baseURL = 'http://39.100.247.54:8933/';
    // }

    if (store.getters.token) {
      /* eslint no-param-reassign: "error" */
      config.headers.token = `${getToken()}`;
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const {
      data,
      ret_code,
      ret_msg,
      msg,
    } = response.data;

    if(~~ret_code === 1) {
      Message({
        message: ret_msg || msg || 'Error',
        type: 'error',
        duration: 5 * 1000,
      });
    }

    if(~~ret_code === 1 && msg == 'token验证失败或已过期') {
      window.close();

      alert(`${msg},请重新登录！`);
      localStorage.clear();
      wps.ribbonUI.Invalidate();
    }

    if(~~ret_code === 0) {
      return response.data;
    }
    // console.log(response, data);

    // if (~~code !== 200) {
    //   if (~~code === 401) {
    //     store.dispatch('user/resetToken').then(() => {
    //       window.location.reload();
    //     });
    //   }

    //   return Promise.reject(new Error(message || 'Error'));
    // }

    return data || response.data;
  },
  (error) => {
    const { response } = error;

    // 所有接口如果报错，查询token是否失效
    store.dispatch('user/inspectionToken');

      // 校对接口
      const { url } = response.config;

      if(url == '/do/do') {
        const err = new Error('Response Error');
        return Promise.reject(err);
      }

    if (response) {
      const { code, message } = response.data || {};

      const err = new Error(message || 'Response Error');
      err.code = code;


      // token过期需页面跳转
      // if (~~code === 403) {
      //   store.dispatch('user/resetToken').then(() => {
      //     window.location.reload();
      //   });
      // }

      return Promise.reject(err);
    }

    return Promise.reject(error);
  },
);

export default service;
